// Front-facing labels for backend enum values + value formatters, shared by ReportRunner.
const VALUE_LABELS = {
   discrepancy_type: {
      amount_variance: "Amount variance",
      date_variance: "Date variance",
      on_statement_not_erp: "On statement, not in ERP",
      in_erp_not_statement: "In ERP, not on statement",
      unexpected_credit: "Unexpected credit",
      partial_short: "Partial / short-paid",
   },
   match_status: {
      FULL_MATCH: "Full match",
      PARTIAL_MATCH: "Partial match",
      UNMATCHED: "Unmatched",
      NO_ERP: "Not in ERP",
      DUPLICATE_OVER_ALLOCATED: "Over-allocated",
      POSSIBLE_KEYING_ERROR: "Possible keying error",
      INVOICE_NUMBER_MATCH_ONLY: "Invoice # match only",
      IGNORED: "Ignored",
   },
   line_type: { discount: "Discount", credit: "Credit" },
   status: { COMPLETE: "Complete", IN_PROGRESS: "In progress" },
   final_step: {
      PRESIGN: "Presign", UPLOAD: "Upload", DISPATCH: "Dispatch",
      EXTRACT: "Extract", LOAD: "Load", PROCESS: "Process",
      MATCH: "Match", FINALIZE: "Finalize",
   },
   tier: {
      "High (>=95%)": "High (≥95%)",
      "Medium (80-94%)": "Medium (80–94%)",
      "Low (<80%)": "Low (<80%)",
   },
};

// snake_case / UPPER_CASE → "Sentence case"; values that already contain
// spaces (age buckets, tiers) pass through unchanged.
export function prettify(v) {
   if (v == null || v === "") return "";
   const s = String(v);
   if (/\s/.test(s)) return s;
   return s.toLowerCase().replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
}

// Look up a curated label for (field, raw); fall back to prettify().
export function valueLabel(field, raw) {
   if (raw == null) return "";
   const m = VALUE_LABELS[field];
   if (m && m[raw] != null) return m[raw];
   return prettify(raw);
}

// Seconds → "45s" / "2m 14s" / "1h 3m".
export function formatDuration(sec) {
   if (sec == null || sec === "") return "";
   const n = Math.max(0, Math.round(Number(sec)));
   if (Number.isNaN(n)) return "";
   if (n < 60) return `${n}s`;
   const h = Math.floor(n / 3600);
   const m = Math.floor((n % 3600) / 60);
   const s = n % 60;
   return h > 0 ? `${h}h ${m}m` : `${m}m ${s}s`;
}
